import React, { useState, useEffect, useRef } from "react";
import bannerImg from "../assets/images/House5.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAward,
  faEnvelope,
  faPhone,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import placeholder from "../assets/images/house-placeholder.webp";
import { Link } from "react-router-dom";
import imgs from "./temp.json";
import calc from "../assets/images/shutterstock_2489188913-min.jpg";
import report from "../assets/images/shutterstock_699442570-min.jpg";
import house from "../assets/images/shutterstock_2493365641-min.jpg";
import constants from "../constants/constants";
import isReactSnap from "../utils/isReactSnap";
import Contact from "./contact.component";

export default function Homepage() {
  const [listings, setListings] = useState([]);
  const [media, setMedia] = useState(imgs.thumbs.value);
  const [formatted, setFormatted] = useState({});
  const loaded = useRef(false);
  const [windowSize, setWindowSize] = useState(window.innerWidth);

  const loadedRef = useRef(false);

  const onWindowResize = () => {
    setWindowSize(window.innerWidth);
  };
  useEffect(() => {
    window.addEventListener("resize", onWindowResize);
    return () => {
      window.removeEventListener("resize", onWindowResize);
    };
  }, []);

  function getData() {
    // Skip API calls during static generation
    if (isReactSnap()) {
      return Promise.resolve({ value: [] });
    }

    const upstreamUrl = `https://query.ampre.ca/odata/Property?$filter=(ListAgentKey eq '${constants.AGENT_ID}' and StandardStatus eq 'Active')&$orderby=OriginalEntryTimestamp desc,ListingKey&$top=12`;
    const body = {
      url: upstreamUrl,
      needAuth: true,
      bearerToken: constants.TOKEN,
    };

    return new Promise(async (resolve, reject) => {
      try {
        // Use metaGet for local dev; use same-origin PHP proxy in production to avoid CORS
        const isLocal =
          typeof window !== "undefined" &&
          (window.location.hostname === "localhost" ||
            window.location.hostname === "127.0.0.1");
        if (isLocal) {
          const data = await fetch(`http://${constants.URL}/metaGet`, {
            method: "POST",
            body: JSON.stringify(body),
            headers: { "Content-Type": "application/json" },
          });
          if (data.ok) {
            const res = await data.json();
            resolve(res);
          } else {
            reject("Failed to fetch data");
          }
        } else {
          // Build PHP proxy path
          const idx = upstreamUrl.indexOf("odata/");
          const path = idx >= 0 ? upstreamUrl.substring(idx) : upstreamUrl;
          const encoded = encodeURIComponent(
            path.replaceAll("?", "(Q)").replaceAll(" ", "(S)").replaceAll("&", "(A)")
          );
          const proxyUrl = `https://${constants.DOMAIN}/proxy.php?path=${encoded}`;
          const resp = await fetch(proxyUrl, { method: "GET" });
          if (!resp.ok) throw new Error("Failed to fetch property data");
          const res = await resp.json();
          resolve(res);
        }
      } catch (err) {
        reject(err);
      }
    });
  }

  function getMedia(listings) {
    // Skip API calls during static generation
    if (isReactSnap() || !listings || listings.length === 0) {
      return Promise.resolve({ value: [] });
    }

    // Build upstream Media query against query.ampre.ca and proxy via metaGet (prod & dev)
    let upstream = `https://query.ampre.ca/odata/Media?$filter=ResourceRecordKey in (`;
    for (let l of listings) {
      upstream += `'${l.ListingKey}',`;
    }
    upstream = upstream.slice(0, -1);
    upstream += ") and ImageSizeDescription eq 'Medium' and PreferredPhotoYN eq true";

    const body = {
      url: upstream,
      needAuth: true,
      bearerToken: constants.TOKEN,
    };

    return new Promise(async (resolve, reject) => {
      try {
        const isLocal =
          typeof window !== "undefined" &&
          (window.location.hostname === "localhost" ||
            window.location.hostname === "127.0.0.1");
        if (isLocal) {
          const resp = await fetch(`http://${constants.URL}/metaGet`, {
            method: "POST",
            body: JSON.stringify(body),
            headers: { "Content-Type": "application/json" },
          });
          if (resp.ok) {
            const res = await resp.json();
            resolve(res);
          } else {
            reject("Failed to fetch data");
          }
        } else {
          // Use same-origin PHP proxy in production
          const idx = upstream.indexOf("odata/");
          const path = idx >= 0 ? upstream.substring(idx) : upstream;
          const encoded = encodeURIComponent(
            path.replaceAll("?", "(Q)").replaceAll(" ", "(S)").replaceAll("&", "(A)")
          );
          const proxyUrl = `https://${constants.DOMAIN}/proxy.php?path=${encoded}`;
          const resp = await fetch(proxyUrl, { method: "GET" });
          if (resp.ok) {
            const res = await resp.json();
            resolve(res);
          } else {
            reject("Failed to fetch data");
          }
        }
      } catch (err) {
        reject(err);
      }
    });
  }

  function formatMedia(media) {
    var temp = {};

    for (let img of media) {
      if (temp[img.ResourceRecordKey]) {
        temp[img.ResourceRecordKey] = [...temp[img.ResourceRecordKey], img];
      } else {
        temp[img.ResourceRecordKey] = [img];
      }
    }
    return temp;
  }

  useEffect(() => {
    if (!loadedRef.current) {
      loadedRef.current = true;
      var temp1 = [];
      getData()
        .then((data) => {
          setListings(data.value);
          getMedia(data.value)
            .then((d) => {
              setMedia(d.value);
              temp1 = d.value;
              setFormatted(formatMedia(d.value));
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });

      loaded.current = true;
    }
  }, []);

  return (
    <>
      <div
        className="w-full bg-no-repeat bg-cover bg-center min-h-[90vh] relative"
        style={{ backgroundImage: `url(${bannerImg})` }}
      >
        <div className="p-12 bg-logo-main w-min absolute top-[30%] left-[10%]">
          <h1 className="text-white text-3xl sm:text-5xl font-mont">
            {constants.AGENT_NAME.split(" ")[0].toUpperCase()}
          </h1>
          <h1 className="text-white text-3xl sm:text-5xl font-mont">
            {constants.AGENT_NAME.split(" ")[1].toUpperCase()}
          </h1>
          <h4 className="text-white text-xl font-mont mt-5 whitespace-normal italic">
            {constants.AGENT_TITLE},
          </h4>
          <h4 className="text-white text-xl font-mont whitespace-normal">
            {constants.BROKERAGE}
          </h4>
        </div>
      </div>
      <div className="bg-logo-second min-[445px]:p-20 px-10 py-14 mx-auto mt-16 flex flex-col md:flex-row gap-y-10 gap-x-14 max-w-[900px]">
        <img src={constants.HEADSHOT} className="h-64 self-start" />
        <div>
          <h1 className="font-mont text-white text-2xl italic">
            "{constants.QUOTE}"
          </h1>
          <p className="text-white mt-4 text-xl font-mont font-semibold">
            {constants.AGENT_NAME}
          </p>
          <p className="text-white mt-1 text-lg font-mont">
            {constants.BROKERAGE}
          </p>
        </div>
      </div>
      <div
        style={{ gridTemplateColumns: "1fr auto 1fr" }}
        className="grid items-end max-w-[1100px] mx-auto px-7"
      >
        <span></span>
        <h1 className="text-4xl text-black py-8 font-mont text-center mt-6">
          Featured Listings
        </h1>
        {windowSize > 650 ? (
          <Link
            className="underline font-semibold underline-offset-4 text-black pb-9 justify-self-end"
            to={"/listings"}
          >
            View All
          </Link>
        ) : null}
      </div>
      <div className="grid listing-grid gap-9 max-w-[1100px] mx-auto px-7">
        {listings?.map((prop) => (
          <Link style={{maxWidth: "900px"}} className="w-full h-full" to={`listing/${prop?.ListingKey}`}>
            <div className="relative w-full aspect-[5/3] sm:aspect-[4/3] overflow-hidden">
              <img
                className="w-full h-full object-cover"
                src={formatted[prop?.ListingKey]?.[0]?.MediaURL ?? placeholder}
              />
              <div className="px-2 py-1 bg-logo-second absolute bottom-0 w-full max-h-[56px]">
                <span className=" text-white text-sm font-mont font-semibold">
                  {prop?.CityRegion ?? prop?.CrossStreet}
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
      <h1 className="text-4xl text-black py-8 font-mont text-center mt-6">
        USEFUL TOOLS
      </h1>
      <div className="grid md:grid-cols-3 gap-10 child:overflow-hidden max-w-[1100px] mx-auto px-7 mb-10">
        <Link to={"/calculator"}>
          <div className="overflow-hidden h-96">
            <img
              className="h-full w-full object-cover hover:scale-105 duration-700"
              src={calc}
            />
          </div>
          <h3 className="text-2xl text-black pt-5 pb-2 font-mont">
            Mortgage Calculator
          </h3>
          <span className="font-mont">
            Find a price range that works with your budget by using our Mortgage
            Calculator
          </span>
        </Link>
        <Link to={"/real-estate-reports"}>
          <div className="overflow-hidden h-96">
            <img
              className="h-full w-full object-cover hover:scale-105 duration-700"
              src={report}
            />
          </div>
          <h3 className="text-2xl text-black pt-5 pb-2 font-mont">
            Real Estate Reports
          </h3>
          <span className="font-mont">
            Gain valuable insights into the market with our free Real Estate
            Reports
          </span>
        </Link>
        <Link to={"/evaluation"}>
          <div className="overflow-hidden h-96">
            <img
              className="h-full w-full object-cover hover:scale-105 duration-700"
              src={house}
            />
          </div>
          <h3 className="text-2xl text-black pt-5 pb-2 font-mont">
            Home Evaluation
          </h3>
          <span className="font-mont">
            How much is your home worth in today's market? Find out with our
            free Home Evaluation
          </span>
        </Link>
      </div>
      <div className="w-full bg-light-grey flex flex-wrap gap-x-16 gap-y-10 justify-center py-16 px-7">
        <Contact />
      </div>
    </>
  );
}
